import { render, staticRenderFns } from "./settingStructureCompany.vue?vue&type=template&id=104bc03a&"
import script from "./settingStructureCompany.vue?vue&type=script&lang=js&"
export * from "./settingStructureCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports